import type { OutOfPageAdType } from '@/modules/adv/index'

export type BannerSequenceConfig = Partial<Record<OutOfPageAdType, { nextType: OutOfPageAdType; duration: number }>>
export const bannerSequenceConfig: BannerSequenceConfig = {
    interstitial_preroll: {
        nextType: 'interstitial_preroll_2',
        duration: 10,
    },
    rewarded: {
        nextType: 'rewarded_2',
        duration: 25,
    },
}
